var map = {
	"./acontroller_selected.png": 4946,
	"./additional_controller_selected.png": 6856,
	"./battery_selected.png": 1341,
	"./bill_selected.png": 8046,
	"./box_selected.png": 4386,
	"./button_selected.png": 4592,
	"./cameraglass_selected.png": 4026,
	"./cd_selected.png": 1627,
	"./charger_selected.png": 1168,
	"./chargingport_selected.png": 529,
	"./controller_selected.png": 9585,
	"./fingertouch_selected.png": 2733,
	"./frontcamera_selected.png": 4282,
	"./hdmi_selected.png": 5850,
	"./keyboard_selected.png": 9320,
	"./lan_selected.png": 8878,
	"./microphone_selected.png": 2326,
	"./mouse_selected.png": 1324,
	"./original_controllers_selected.png": 9543,
	"./powerbutton_selected.png": 7150,
	"./proximitysensor_selected.png": 5497,
	"./rearcamera_selected.png": 6611,
	"./remote_selected.png": 9448,
	"./simcard_selected.png": 2321,
	"./speaker_selected.png": 3005,
	"./speakerbutton_selected.png": 1834,
	"./touchpad_selected.png": 3251,
	"./trackpad_selected.png": 3255,
	"./usb_selected.png": 8981,
	"./vibrator_selected.png": 8311,
	"./volume_selected.png": 4454,
	"./webcamera_selected.png": 2217,
	"./wifibluetooth_selected.png": 7091
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5880;